module.exports = __webpack_public_path__ + "img/delete.d66ad02a.svg";